import { call, put, select } from 'redux-saga/effects';
import { EMPTY_TEXT } from '@mitchell/react.component.ux';
import { photoCaptureIntelligentImageDetailOCRSuccessAction, photoCaptureIntelligentImageDetailOCRFailureAction, photoCaptureIntelligentOCRAction } from '../actions';
import { PhotoCaptureIntelligentImageDetailOCRService } from '../services';
import { OCR_SERVICE_MAPPING } from '../constants';
import { getOCRRequestPayload, shouldEnableOCR } from '../utilities';
import { getQuestionnaireEvaluationQuestionAttributeType } from "../../questionnaireEvaluation";
import { getShouldAllowMitchellIntelligent, getShouldEnableOCRImageTextDecode } from '../selectors';
export function* photoCaptureIntelligentImageDetailOCRSaga(action, photoCaptureImageDetailOCRService = new PhotoCaptureIntelligentImageDetailOCRService()) {
    const questionSubType = yield select(getQuestionnaireEvaluationQuestionAttributeType);
    const shouldAllowMitchellIntelligent = yield select(getShouldAllowMitchellIntelligent);
    const shouldEnableOCRImageTextDecode = yield select(getShouldEnableOCRImageTextDecode);
    const { files } = action.payload;
    const isOcrEnabled = shouldEnableOCR(questionSubType);
    try {
        let requestPayload;
        if (shouldAllowMitchellIntelligent && shouldEnableOCRImageTextDecode && isOcrEnabled) {
            yield put(photoCaptureIntelligentOCRAction());
            const imageDocUID = files && files[0].docUID;
            const attribute = OCR_SERVICE_MAPPING[questionSubType];
            const referenceId = EMPTY_TEXT;
            requestPayload = yield call(getOCRRequestPayload, imageDocUID, referenceId, attribute);
            const response = yield call({
                context: photoCaptureImageDetailOCRService,
                fn: photoCaptureImageDetailOCRService.photoCaptureImageDetailOCR
            }, requestPayload);
            yield put(photoCaptureIntelligentImageDetailOCRSuccessAction({
                requestUid: response.requestUid,
                results: response.results
            }, questionSubType));
        }
    }
    catch (error) {
        yield put(photoCaptureIntelligentImageDetailOCRFailureAction(error.toString()));
    }
}
//# sourceMappingURL=intelligentPhotoCaptureImageDetailOCRSaga.js.map